import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 0h16v24H16V0z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h16v24H0V0z",
      fill: "#36A400"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.791 6.795c1.521 0 2.91.56 3.974 1.487a7.353 7.353 0 100 9.128A6.051 6.051 0 1117.79 6.795zm2.82 2.749l-1.703 1.93-2.445-.675 1.355 2.12-1.355 2.258 2.565-.923 1.402 2.188v-2.54l2.291-.982-2.291-.821.18-2.555z",
      fill: "red"
    }
  )
);
export {
  t as default
};
